// 最新吃瓜 —— 全站内容数据（简体中文，纯展示用 mock）

export interface FeedItem {
  id: string;
  tag: string;
  date: string;
  title: string;
  summary: string;
  hot: number;
  image: string;
  source: string;
}

export interface MonthRank {
  id: string;
  rank: number;
  tag: string;
  title: string;
  summary: string;
  heat: string;
}

export interface Person {
  id: string;
  title: string;
  keywords: string;
  desc: string;
  image: string;
  scene: string;
}

export interface Faq {
  q: string;
  a: string;
}

// 热搜词
export const trendingWords: string[] = [
  "晚风来信",
  "幕后新声",
  "联名真香",
  "音乐节大合唱",
  "顶流回归",
  "国货翻红",
  "演出经济回暖",
  "治愈向剧集",
  "剧本杀进文旅",
  "下饭剧之王",
];

// 本周瓜汇总
export const weeklyFeed: FeedItem[] = [
  {
    id: "week-01",
    tag: "影视",
    date: "09-08",
    title: "都市剧《晚风来信》开播即热，导演回应“治愈向新解法”",
    summary:
      "首周播放数据冲上同期第一，主创团队称不想贩卖焦虑，只想给都市人一段“慢慢来的故事”。网友评价两极又上头，成近期讨论度最高的下饭剧。",
    hot: 96,
    image:
      "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20cinema%20studio%20spotlight%20and%20film%20clapperboard%20in%20a%20cozy%20evening%20apartment%2C%20warm%20coral%20orange%20and%20cream%20tones%20with%20fresh%20green%20accents%2C%20playful%20bold%20shapes%2C%20clean%20modern%20minimal%20composition%20with%20soft%20curved%20background&width=720&height=480&seq=gua-film-01&orientation=landscape",
    source: "综合报道",
  },
  {
    id: "week-02",
    tag: "综艺",
    date: "09-07",
    title: "音综《幕后新声》救场名场面刷屏，评审即兴点评破圈",
    summary:
      "一场设备临时故障，反倒成就了当晚最出圈的即兴舞台。相关二创视频播放量三天破千万，“把意外变成高光”的综艺逻辑被反复讨论。",
    hot: 91,
    image:
      "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20music%20variety%20show%20stage%20with%20glowing%20spotlights%20and%20crowd%20silhouettes%2C%20warm%20coral%20and%20amber%20palette%20with%20fresh%20green%20accents%2C%20playful%20modern%20minimal%20geometric%20style%2C%20clean%20composition&width=720&height=480&seq=gua-show-02&orientation=landscape",
    source: "节目动态",
  },
  {
    id: "week-03",
    tag: "品牌",
    date: "09-06",
    title: "国货联名“翻车又翻红”，从全网吐槽到真香只隔一夜",
    summary:
      "首批限定开箱测评翻车后，官方连夜回应并调整工艺，第二天口碑原地反转。这场“翻红”成为今年品牌危机公关里最值得复盘的一课。",
    hot: 88,
    image:
      "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20playful%20limited%20edition%20product%20boxes%20and%20shopping%20bags%20on%20a%20warm%20cream%20background%2C%20coral%20orange%20and%20fresh%20green%20collaboration%20packaging%2C%20bold%20modern%20minimal%20geometric%20shapes%2C%20cheerful%20commercial%20illustration%20style&width=720&height=480&seq=gua-brand-03&orientation=landscape",
    source: "商业观察",
  },
  {
    id: "week-04",
    tag: "行业",
    date: "09-05",
    title: "头部主播回归首播，选品与售后策略成新行业样本",
    summary:
      "停更数月后低调回归，首场不再拼价格战，转而讲“售后与长期主义”。业内认为，这场直播给直播间竞争提供了全新的打法参考。",
    hot: 84,
    image:
      "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20modern%20live%20streaming%20studio%20with%20ring%20light%20and%20product%20table%2C%20warm%20coral%20and%20cream%20tones%20with%20green%20accent%20plants%2C%20playful%20minimal%20geometric%20composition%2C%20clean%20background&width=720&height=480&seq=gua-live-04&orientation=landscape",
    source: "行业趋势",
  },
  {
    id: "week-05",
    tag: "文娱",
    date: "09-04",
    title: "音乐节现场大合唱时长破纪录，乐迷直呼值回票价",
    summary:
      "压轴演出时全场同声大合唱持续近十分钟，主办方临时加开放送环节。线下演出的情绪价值，正在成为今年最被看重的体验。",
    hot: 82,
    image:
      "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20an%20outdoor%20music%20festival%20night%20scene%20with%20stage%20lights%20and%20cheering%20crowd%2C%20warm%20coral%20orange%20and%20amber%20glow%20with%20fresh%20green%20and%20cream%2C%20bold%20playful%20modern%20minimal%20style&width=720&height=480&seq=gua-music-05&orientation=landscape",
    source: "现场直击",
  },
];

// 本月盘点
export const monthlyRank: MonthRank[] = [
  {
    id: "month-01",
    rank: 1,
    tag: "影视",
    title: "现象级剧集口碑之争",
    summary:
      "从“烂尾预警”到“神作收官”，本月讨论度最高的剧集用一场口碑逆转，把“追剧情绪”做成了最热话题。",
    heat: "127万热度",
  },
  {
    id: "month-02",
    rank: 2,
    tag: "综艺",
    title: "综艺“名场面”营销出圈",
    summary:
      "不再拼嘉宾咖位，转而在“即兴与意外”里找看点，多档综艺靠名场面完成低成本破圈。",
    heat: "98万热度",
  },
  {
    id: "month-03",
    rank: 3,
    tag: "品牌",
    title: "联名“翻车—修复—翻红”全复盘",
    summary:
      "一次翻车事故如何变成品牌信任加分项？公关团队在24小时内的反应速度，成了业内教科书。",
    heat: "85万热度",
  },
  {
    id: "month-04",
    rank: 4,
    tag: "文娱",
    title: "IP改编电影定档引围观",
    summary:
      "高人气IP真人化消息一出，书粉与路人的讨论直接冲上热榜，选角与世界观还原成最大焦点。",
    heat: "76万热度",
  },
  {
    id: "month-05",
    rank: 5,
    tag: "行业",
    title: "线下演出经济全面回暖",
    summary:
      "演唱会、音乐节、话剧轮番开票，热门场次“秒空”。线下文娱正在找回属于它的热闹。",
    heat: "63万热度",
  },
];

// 新近合集（可切换筛选）
export const collectionFeed: FeedItem[] = [
  {
    id: "col-01",
    tag: "影视",
    date: "09-08",
    title: "《晚风来信》全员演技被夸，配角线意外出圈",
    summary:
      "主角之外，一条“小人物”副线被网友反复截图，连演员本人都没想到自己会靠角色翻红。",
    hot: 95,
    image:
      "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20cinema%20studio%20spotlight%20and%20film%20clapperboard%20in%20a%20cozy%20evening%20apartment%2C%20warm%20coral%20orange%20and%20cream%20tones%20with%20fresh%20green%20accents%2C%20playful%20bold%20shapes%2C%20clean%20modern%20minimal%20composition%20with%20soft%20curved%20background&width=800&height=500&seq=gua-film-01&orientation=landscape",
    source: "豆瓣热评",
  },
  {
    id: "col-02",
    tag: "综艺",
    date: "09-07",
    title: "《幕后新声》即兴舞台成年度名场面候选",
    summary:
      "一场设备故障意外促成高光时刻，评审团临场点评引发全网二创，播放量持续攀升。",
    hot: 92,
    image:
      "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20music%20variety%20show%20stage%20with%20glowing%20spotlights%20and%20crowd%20silhouettes%2C%20warm%20coral%20and%20amber%20palette%20with%20fresh%20green%20accents%2C%20playful%20modern%20minimal%20geometric%20style&width=800&height=500&seq=gua-show-02&orientation=landscape",
    source: "节目动态",
  },
  {
    id: "col-03",
    tag: "品牌",
    date: "09-06",
    title: "限量联名口碑“翻红”，官方深夜道歉成转折点",
    summary:
      "从差评刷屏到补货秒空，官方用一场真诚回应挽回了口碑，也给自己上了一课。",
    hot: 89,
    image:
      "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20playful%20limited%20edition%20product%20boxes%20and%20shopping%20bags%20on%20a%20warm%20cream%20background%2C%20coral%20orange%20and%20fresh%20green%20collaboration%20packaging%2C%20bold%20modern%20minimal%20geometric%20shapes&width=800&height=500&seq=gua-brand-03&orientation=landscape",
    source: "商业观察",
  },
  {
    id: "col-04",
    tag: "社媒",
    date: "09-05",
    title: "“朋友圈式请假条”爆火，打工人共鸣刷屏",
    summary:
      "一张不走套路的请假条意外走红，网友纷纷晒出自己的同款“花式请假”，情绪共鸣拉满。",
    hot: 86,
    image:
      "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20people%20scrolling%20social%20media%20on%20phones%20with%20floating%20chat%20bubbles%20and%20hearts%2C%20warm%20coral%20and%20cream%20tones%20with%20fresh%20green%20accents%2C%20playful%20modern%20minimal%20style%2C%20clean%20background&width=800&height=500&seq=gua-gossip-07&orientation=landscape",
    source: "微博热榜",
  },
  {
    id: "col-05",
    tag: "社媒",
    date: "09-04",
    title: "音乐节“大合唱”片段全网流传，线下载体又火一把",
    summary:
      "一段近十分钟的全场大合唱视频被反复转发，线下演出的氛围感再次被推到台前。",
    hot: 83,
    image:
      "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20an%20outdoor%20music%20festival%20night%20scene%20with%20stage%20lights%20and%20cheering%20crowd%2C%20warm%20coral%20orange%20and%20amber%20glow%20with%20fresh%20green%20and%20cream%2C%20bold%20playful%20modern%20minimal%20style&width=800&height=500&seq=gua-music-05&orientation=landscape",
    source: "二创热传",
  },
  {
    id: "col-06",
    tag: "影视",
    date: "09-03",
    title: "高人气IP真人化公布，书粉现场“开考”还原度",
    summary:
      "定档消息与选角同天公布，粉丝连夜制作还原度对比图，期待与担忧一起冲上热搜。",
    hot: 80,
    image:
      "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20cinema%20screen%20with%20film%20reel%20and%20popcorn%2C%20warm%20coral%20and%20amber%20tones%20with%20fresh%20green%20accent%2C%20playful%20modern%20minimal%20geometric%20style%2C%20clean%20warm%20background&width=800&height=500&seq=gua-movie-06&orientation=landscape",
    source: "影视热议",
  },
];

// 热门人物
export const people: Person[] = [
  {
    id: "p-01",
    title: "“国民剧”新女主",
    keywords: "治愈、爆发力、反差",
    desc: "靠一部都市剧从配角跃升主演，选戏眼光被夸“会挑”，是本月被提起次数最多的女演员。",
    scene: "影视 · 上升期",
    image:
      "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20avatar%20of%20a%20young%20cheerful%20actress%20portrait%20in%20warm%20coral%20and%20cream%20tones%2C%20fresh%20green%20accent%20background%2C%20playful%20modern%20minimal%20style%2C%20clean%20soft%20shapes%2C%20no%20text&width=320&height=320&seq=gua-avatar-01&orientation=squarish",
  },
  {
    id: "p-02",
    title: "综艺“救场担当”",
    keywords: "即兴、情商、名场面",
    desc: "因为一段临场救场被全网点赞，应变能力与分寸感成为网友口中的“教科书级现场”。",
    scene: "综艺 · 高光时刻",
    image:
      "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20avatar%20of%20a%20confident%20young%20male%20host%20portrait%2C%20warm%20coral%20and%20amber%20tones%20with%20cream%20background%2C%20playful%20modern%20minimal%20style%2C%20soft%20geometric%20shapes%2C%20no%20text&width=320&height=320&seq=gua-avatar-02&orientation=squarish",
  },
  {
    id: "p-03",
    title: "回归带货主播",
    keywords: "长期主义、选品、售后",
    desc: "放弃低价战、转讲服务细节的回归首秀，被当作“直播间下半场”的风向标。",
    scene: "行业 · 转型样本",
    image:
      "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20avatar%20of%20a%20warm%20smiling%20female%20livestream%20host%20portrait%2C%20coral%20orange%20and%20cream%20tones%20with%20fresh%20green%20accent%2C%20playful%20modern%20minimal%20style%2C%20clean%20background%2C%20no%20text&width=320&height=320&seq=gua-avatar-03&orientation=squarish",
  },
  {
    id: "p-04",
    title: "新锐音乐制作人",
    keywords: "独立、黑马、破圈",
    desc: "一首“反套路”作品意外走红，词曲风格被乐评人称作“今年最惊喜的新声音”。",
    scene: "音乐 · 新锐力量",
    image:
      "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20avatar%20of%20a%20young%20music%20producer%20with%20headphones%20portrait%2C%20warm%20amber%20and%20fresh%20green%20tones%20with%20cream%20background%2C%20playful%20modern%20minimal%20style%2C%20no%20text&width=320&height=320&seq=gua-avatar-04&orientation=squarish",
  },
  {
    id: "p-05",
    title: "脱口秀“黑马”",
    keywords: "犀利、共情、爆梗",
    desc: "用一段关于“生活小事”的段子击中无数人，一夜之间成为短视频平台的新宠。",
    scene: "喜剧 · 破圈新人",
    image:
      "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20avatar%20of%20a%20lively%20young%20male%20standup%20comedian%20with%20microphone%20portrait%2C%20warm%20coral%20and%20cream%20tones%20with%20green%20accent%2C%20playful%20modern%20minimal%20style%2C%20clean%20background%2C%20no%20text&width=320&height=320&seq=gua-avatar-05&orientation=squarish",
  },
];

// 常见问题
export const faqs: Faq[] = [
  {
    q: "网站多久更新一次热点？",
    a: "「最新速递」几乎每日滚动更新，第一时间跟进当天新近动态；「本周瓜汇总」每周一集中整理本周最热事件；「本月盘点」则在每月末一次性回顾整个月的重点走向，方便你集中补课。",
  },
  {
    q: "为什么分成本周、本月、新近合集三类？",
    a: "三类内容对应不同的补课颗粒度：想看这几天发生的就翻最新速递；想一周一周系统回顾就点本周瓜汇总；想把握月度大趋势则直接看本月盘点。三者互补，覆盖不同阅读习惯。",
  },
  {
    q: "这些信息从哪来，可信吗？",
    a: "所有内容均基于多家公开媒体与官方渠道的报道、声明综合整理，并在文中注明信息来源。我们不采信单一匿名爆料，也会在事件未明朗时明确标注“持续跟进”，帮助你在吃瓜时更理性判断。",
  },
  {
    q: "可以投稿线索或纠错吗？",
    a: "当然可以。如果你发现我们有事实错误或漏掉的重要公开事件，欢迎通过底部邮箱或订阅表单留言。核实属实的线索我们会在后续盘点中补充并致谢。",
  },
  {
    q: "内容可以转载分享吗？",
    a: "个人与媒体非商业转载，注明来源「最新吃瓜」即可；商业转载或其他合作请先通过网站底部联系方式与我们沟通，避免版权问题。",
  },
  {
    q: "如何第一时间收到最新热点？",
    a: "最方便的是在下方订阅「瓜报周讯」，每周整理好一周重点直接发到你的邮箱。无需注册，退订也一键完成，不会打扰你。",
  },
];

// 用户口碑
export const testimonials: { name: string; role: string; text: string }[] = [
  {
    name: "小鹿乱撞",
    role: "上班族 · 追剧重度用户",
    text: "工作忙到没空刷微博，全靠「本周瓜汇总」每周一次补齐，一期十分钟，再也不怕同事聊天插不上话了。",
  },
  {
    name: "阿瓜本瓜",
    role: "大学生 · 吃瓜爱好者",
    text: "最喜欢它的「本月盘点」，把一整月的事情理成一条线，看着特别清楚，比零散刷帖强太多了。",
  },
  {
    name: "半糖拿铁",
    role: "自由职业者",
    text: "信息来源都标注得很清楚，不像很多地方动不动就标题党。虽然叫吃瓜，但读起来意外地理性舒服。",
  },
];